var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskCompletedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CheckCircleFilled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.7744 2C7.25441 2 2.77441 6.48 2.77441 12C2.77441 17.52 7.25441 22 12.7744 22C18.2944 22 22.7744 17.52 22.7744 12C22.7744 6.48 18.2944 2 12.7744 2ZM10.7744 17L5.77441 12L7.18441 10.59L10.7744 14.17L18.3644 6.58L19.7744 8L10.7744 17Z",
    fill: "#76FF03"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskCompletedIcon);
export default __webpack_public_path__ + "static/media/TaskCompletedIcon.a5306af93341e1474f1ba1fe90f1f043.svg";
export { ForwardRef as ReactComponent };